// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/jigsaw.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { SpatialPosition } from "../metrics/metrics";
import { DB } from "./db";
import {
  CategorySource,
  categorySourceFromJSON,
  categorySourceToJSON,
  EntryTimingGrade,
  entryTimingGradeFromJSON,
  entryTimingGradeToJSON,
  MetricDataSource,
  metricDataSourceFromJSON,
  metricDataSourceToJSON,
} from "./metrics";

export const protobufPackage = "carbon.portal.health";

export enum JigsawMetricsView {
  JIGSAW_METRICS_VIEW_UNSPECIFIED = 0,
  JIGSAW_METRICS_VIEW_OPS_CENTER = 1,
  JIGSAW_METRICS_VIEW_COMPANION = 2,
  UNRECOGNIZED = -1,
}

export function jigsawMetricsViewFromJSON(object: any): JigsawMetricsView {
  switch (object) {
    case 0:
    case "JIGSAW_METRICS_VIEW_UNSPECIFIED":
      return JigsawMetricsView.JIGSAW_METRICS_VIEW_UNSPECIFIED;
    case 1:
    case "JIGSAW_METRICS_VIEW_OPS_CENTER":
      return JigsawMetricsView.JIGSAW_METRICS_VIEW_OPS_CENTER;
    case 2:
    case "JIGSAW_METRICS_VIEW_COMPANION":
      return JigsawMetricsView.JIGSAW_METRICS_VIEW_COMPANION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JigsawMetricsView.UNRECOGNIZED;
  }
}

export function jigsawMetricsViewToJSON(object: JigsawMetricsView): string {
  switch (object) {
    case JigsawMetricsView.JIGSAW_METRICS_VIEW_UNSPECIFIED:
      return "JIGSAW_METRICS_VIEW_UNSPECIFIED";
    case JigsawMetricsView.JIGSAW_METRICS_VIEW_OPS_CENTER:
      return "JIGSAW_METRICS_VIEW_OPS_CENTER";
    case JigsawMetricsView.JIGSAW_METRICS_VIEW_COMPANION:
      return "JIGSAW_METRICS_VIEW_COMPANION";
    case JigsawMetricsView.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface JigsawBlocksCrop {
  id: string;
  localizedName: string;
  categorySource: CategorySource;
  found: number;
  hasThinning: boolean;
}

export interface JigsawBlocksWeed {
  id: string;
  localizedName: string;
  categorySource: CategorySource;
  fractionOfTotal: number;
}

export interface JigsawBlocksResponse {
  blocks: JigsawSpatialMetricBlock[];
  queryLimitReached: boolean;
  dataSource: MetricDataSource;
  crops: JigsawBlocksCrop[];
  weeds: JigsawBlocksWeed[];
}

export interface JigsawSpatialMetricBlock {
  db: DB | undefined;
  start: SpatialPosition | undefined;
  end: SpatialPosition | undefined;
  startLeft: SpatialPosition | undefined;
  startRight: SpatialPosition | undefined;
  endLeft: SpatialPosition | undefined;
  endRight: SpatialPosition | undefined;
  opsCenter?: JigsawSpatialMetricsOpsCenter | undefined;
  companion?: JigsawSpatialMetricsCompanion | undefined;
  hardwareState: HardwareState | undefined;
  BlockWidthMm: number;
  /**
   * True when this block's metrics should be included in aggregations and
   * relative color scales: the robot was actively weeding/thinning with lasers
   * armed and no hardware inhibits (lifted, e-stop, interlock, etc).
   */
  countable: boolean;
  /**
   * Grade from this block's average weed radius and weed count.
   * UNSPECIFIED when there are no weeds or the radius is at or below zero.
   */
  entryTimingGrade: EntryTimingGrade;
}

export interface HardwareState {
  eStop: boolean;
  interlock: boolean;
  laserKey: boolean;
  lifted: boolean;
  waterProtection: boolean;
  hadCoverage: boolean;
  wasThinning: boolean;
  wasWeeding: boolean;
}

export interface OpsCenterSpatialCropMetrics {
  densityPerSquareMeter: number;
  averageRadiusMeters: number;
  found: number;
  thinned: number;
  ignored: number;
  missed: number;
  kept: number;
  /**
   * Use remaining_crop_density_per_sq_meter instead.
   *
   * @deprecated
   */
  keptCropDensityPerSqMeter: number;
  categorySource: CategorySource;
  remainingCropDensityPerSqMeter: number;
}

export interface OpsCenterSpatialWeedMetrics {
  fractionOfTotal: number;
  categorySource: CategorySource;
}

export interface JigsawSpatialMetricsOpsCenter {
  averageCropRadiusMeters: number;
  averageShootTimeSeconds: number;
  averageTargetSpeedMetersPerSecond: number;
  averageTravelSpeedMetersPerSecond: number;
  averageWeedRadiusMeters: number;
  coverageSquareMeters: number;
  cropDensityPerSqMeter: number;
  cropsFound: number;
  cropsIgnored: number;
  cropsKept: number;
  cropsMissed: number;
  cropsThinned: number;
  /**
   * Use remaining_crop_density_per_sq_meter instead.
   *
   * @deprecated
   */
  keptCropDensityPerSqMeter: number;
  overallPerformance: number;
  percentWeedsBroadleaf: number;
  percentWeedsDisregard: number;
  percentWeedsGrass: number;
  percentWeedsOffshoot: number;
  percentWeedsPurslane: number;
  /**
   * prefer banded_area_fraction. same value, different name.
   *
   * @deprecated
   */
  percentageBanded: number;
  targetSpeedRatio: number;
  thinningPerformance: number;
  weedDensityPerSqMeter: number;
  weedingPerformance: number;
  weedsFound: number;
  weedsIgnored: number;
  weedsInBand: number;
  weedsKilled: number;
  weedsMissed: number;
  /** keyed by bare category id */
  cropMetrics: { [key: string]: OpsCenterSpatialCropMetrics };
  weedMetrics: { [key: string]: OpsCenterSpatialWeedMetrics };
  bandedAreaFraction: number;
  remainingCropDensityPerSqMeter: number;
}

export interface JigsawSpatialMetricsOpsCenter_CropMetricsEntry {
  key: string;
  value: OpsCenterSpatialCropMetrics | undefined;
}

export interface JigsawSpatialMetricsOpsCenter_WeedMetricsEntry {
  key: string;
  value: OpsCenterSpatialWeedMetrics | undefined;
}

export interface JigsawSpatialMetricsCompanion {
  averageCropRadiusMeters: number;
  averageTravelSpeedMetersPerSecond: number;
  averageWeedRadiusMeters: number;
  coverageSquareMeters: number;
  cropDensityPerSqMeter: number;
  /**
   * Use remaining_crop_density_per_sq_meter instead.
   *
   * @deprecated
   */
  keptCropDensityPerSqMeter: number;
  overallPerformance: number;
  percentWeedsBroadleaf: number;
  percentWeedsDisregard: number;
  percentWeedsGrass: number;
  percentWeedsOffshoot: number;
  percentWeedsPurslane: number;
  thinningPerformance: number;
  weedDensityPerSqMeter: number;
  weedingPerformance: number;
  remainingCropDensityPerSqMeter: number;
}

export interface JigsawBlocksByJobResponse {
  blocks: { [key: string]: JigsawBlocksResponse };
}

export interface JigsawBlocksByJobResponse_BlocksEntry {
  key: string;
  value: JigsawBlocksResponse | undefined;
}

function createBaseJigsawBlocksCrop(): JigsawBlocksCrop {
  return { id: "", localizedName: "", categorySource: 0, found: 0, hasThinning: false };
}

export const JigsawBlocksCrop: MessageFns<JigsawBlocksCrop> = {
  encode(message: JigsawBlocksCrop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.localizedName !== "") {
      writer.uint32(18).string(message.localizedName);
    }
    if (message.categorySource !== 0) {
      writer.uint32(24).int32(message.categorySource);
    }
    if (message.found !== 0) {
      writer.uint32(32).int64(message.found);
    }
    if (message.hasThinning !== false) {
      writer.uint32(40).bool(message.hasThinning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawBlocksCrop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawBlocksCrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.localizedName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.categorySource = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.found = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.hasThinning = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawBlocksCrop {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      localizedName: isSet(object.localizedName)
        ? globalThis.String(object.localizedName)
        : isSet(object.localized_name)
        ? globalThis.String(object.localized_name)
        : "",
      categorySource: isSet(object.categorySource)
        ? categorySourceFromJSON(object.categorySource)
        : isSet(object.category_source)
        ? categorySourceFromJSON(object.category_source)
        : 0,
      found: isSet(object.found) ? globalThis.Number(object.found) : 0,
      hasThinning: isSet(object.hasThinning)
        ? globalThis.Boolean(object.hasThinning)
        : isSet(object.has_thinning)
        ? globalThis.Boolean(object.has_thinning)
        : false,
    };
  },

  toJSON(message: JigsawBlocksCrop): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.localizedName !== "") {
      obj.localizedName = message.localizedName;
    }
    if (message.categorySource !== 0) {
      obj.categorySource = categorySourceToJSON(message.categorySource);
    }
    if (message.found !== 0) {
      obj.found = Math.round(message.found);
    }
    if (message.hasThinning !== false) {
      obj.hasThinning = message.hasThinning;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawBlocksCrop>, I>>(base?: I): JigsawBlocksCrop {
    return JigsawBlocksCrop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawBlocksCrop>, I>>(object: I): JigsawBlocksCrop {
    const message = createBaseJigsawBlocksCrop();
    message.id = object.id ?? "";
    message.localizedName = object.localizedName ?? "";
    message.categorySource = object.categorySource ?? 0;
    message.found = object.found ?? 0;
    message.hasThinning = object.hasThinning ?? false;
    return message;
  },
};

function createBaseJigsawBlocksWeed(): JigsawBlocksWeed {
  return { id: "", localizedName: "", categorySource: 0, fractionOfTotal: 0 };
}

export const JigsawBlocksWeed: MessageFns<JigsawBlocksWeed> = {
  encode(message: JigsawBlocksWeed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.localizedName !== "") {
      writer.uint32(18).string(message.localizedName);
    }
    if (message.categorySource !== 0) {
      writer.uint32(24).int32(message.categorySource);
    }
    if (message.fractionOfTotal !== 0) {
      writer.uint32(37).float(message.fractionOfTotal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawBlocksWeed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawBlocksWeed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.localizedName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.categorySource = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.fractionOfTotal = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawBlocksWeed {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      localizedName: isSet(object.localizedName)
        ? globalThis.String(object.localizedName)
        : isSet(object.localized_name)
        ? globalThis.String(object.localized_name)
        : "",
      categorySource: isSet(object.categorySource)
        ? categorySourceFromJSON(object.categorySource)
        : isSet(object.category_source)
        ? categorySourceFromJSON(object.category_source)
        : 0,
      fractionOfTotal: isSet(object.fractionOfTotal)
        ? globalThis.Number(object.fractionOfTotal)
        : isSet(object.fraction_of_total)
        ? globalThis.Number(object.fraction_of_total)
        : 0,
    };
  },

  toJSON(message: JigsawBlocksWeed): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.localizedName !== "") {
      obj.localizedName = message.localizedName;
    }
    if (message.categorySource !== 0) {
      obj.categorySource = categorySourceToJSON(message.categorySource);
    }
    if (message.fractionOfTotal !== 0) {
      obj.fractionOfTotal = message.fractionOfTotal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawBlocksWeed>, I>>(base?: I): JigsawBlocksWeed {
    return JigsawBlocksWeed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawBlocksWeed>, I>>(object: I): JigsawBlocksWeed {
    const message = createBaseJigsawBlocksWeed();
    message.id = object.id ?? "";
    message.localizedName = object.localizedName ?? "";
    message.categorySource = object.categorySource ?? 0;
    message.fractionOfTotal = object.fractionOfTotal ?? 0;
    return message;
  },
};

function createBaseJigsawBlocksResponse(): JigsawBlocksResponse {
  return { blocks: [], queryLimitReached: false, dataSource: 0, crops: [], weeds: [] };
}

export const JigsawBlocksResponse: MessageFns<JigsawBlocksResponse> = {
  encode(message: JigsawBlocksResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.blocks) {
      JigsawSpatialMetricBlock.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.queryLimitReached !== false) {
      writer.uint32(16).bool(message.queryLimitReached);
    }
    if (message.dataSource !== 0) {
      writer.uint32(24).int32(message.dataSource);
    }
    for (const v of message.crops) {
      JigsawBlocksCrop.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.weeds) {
      JigsawBlocksWeed.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawBlocksResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawBlocksResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blocks.push(JigsawSpatialMetricBlock.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.queryLimitReached = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dataSource = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.crops.push(JigsawBlocksCrop.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.weeds.push(JigsawBlocksWeed.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawBlocksResponse {
    return {
      blocks: globalThis.Array.isArray(object?.blocks)
        ? object.blocks.map((e: any) => JigsawSpatialMetricBlock.fromJSON(e))
        : [],
      queryLimitReached: isSet(object.queryLimitReached)
        ? globalThis.Boolean(object.queryLimitReached)
        : isSet(object.query_limit_reached)
        ? globalThis.Boolean(object.query_limit_reached)
        : false,
      dataSource: isSet(object.dataSource)
        ? metricDataSourceFromJSON(object.dataSource)
        : isSet(object.data_source)
        ? metricDataSourceFromJSON(object.data_source)
        : 0,
      crops: globalThis.Array.isArray(object?.crops) ? object.crops.map((e: any) => JigsawBlocksCrop.fromJSON(e)) : [],
      weeds: globalThis.Array.isArray(object?.weeds) ? object.weeds.map((e: any) => JigsawBlocksWeed.fromJSON(e)) : [],
    };
  },

  toJSON(message: JigsawBlocksResponse): unknown {
    const obj: any = {};
    if (message.blocks?.length) {
      obj.blocks = message.blocks.map((e) => JigsawSpatialMetricBlock.toJSON(e));
    }
    if (message.queryLimitReached !== false) {
      obj.queryLimitReached = message.queryLimitReached;
    }
    if (message.dataSource !== 0) {
      obj.dataSource = metricDataSourceToJSON(message.dataSource);
    }
    if (message.crops?.length) {
      obj.crops = message.crops.map((e) => JigsawBlocksCrop.toJSON(e));
    }
    if (message.weeds?.length) {
      obj.weeds = message.weeds.map((e) => JigsawBlocksWeed.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawBlocksResponse>, I>>(base?: I): JigsawBlocksResponse {
    return JigsawBlocksResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawBlocksResponse>, I>>(object: I): JigsawBlocksResponse {
    const message = createBaseJigsawBlocksResponse();
    message.blocks = object.blocks?.map((e) => JigsawSpatialMetricBlock.fromPartial(e)) || [];
    message.queryLimitReached = object.queryLimitReached ?? false;
    message.dataSource = object.dataSource ?? 0;
    message.crops = object.crops?.map((e) => JigsawBlocksCrop.fromPartial(e)) || [];
    message.weeds = object.weeds?.map((e) => JigsawBlocksWeed.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJigsawSpatialMetricBlock(): JigsawSpatialMetricBlock {
  return {
    db: undefined,
    start: undefined,
    end: undefined,
    startLeft: undefined,
    startRight: undefined,
    endLeft: undefined,
    endRight: undefined,
    opsCenter: undefined,
    companion: undefined,
    hardwareState: undefined,
    BlockWidthMm: 0,
    countable: false,
    entryTimingGrade: 0,
  };
}

export const JigsawSpatialMetricBlock: MessageFns<JigsawSpatialMetricBlock> = {
  encode(message: JigsawSpatialMetricBlock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.db !== undefined) {
      DB.encode(message.db, writer.uint32(10).fork()).join();
    }
    if (message.start !== undefined) {
      SpatialPosition.encode(message.start, writer.uint32(18).fork()).join();
    }
    if (message.end !== undefined) {
      SpatialPosition.encode(message.end, writer.uint32(26).fork()).join();
    }
    if (message.startLeft !== undefined) {
      SpatialPosition.encode(message.startLeft, writer.uint32(34).fork()).join();
    }
    if (message.startRight !== undefined) {
      SpatialPosition.encode(message.startRight, writer.uint32(42).fork()).join();
    }
    if (message.endLeft !== undefined) {
      SpatialPosition.encode(message.endLeft, writer.uint32(50).fork()).join();
    }
    if (message.endRight !== undefined) {
      SpatialPosition.encode(message.endRight, writer.uint32(58).fork()).join();
    }
    if (message.opsCenter !== undefined) {
      JigsawSpatialMetricsOpsCenter.encode(message.opsCenter, writer.uint32(66).fork()).join();
    }
    if (message.companion !== undefined) {
      JigsawSpatialMetricsCompanion.encode(message.companion, writer.uint32(74).fork()).join();
    }
    if (message.hardwareState !== undefined) {
      HardwareState.encode(message.hardwareState, writer.uint32(90).fork()).join();
    }
    if (message.BlockWidthMm !== 0) {
      writer.uint32(96).int32(message.BlockWidthMm);
    }
    if (message.countable !== false) {
      writer.uint32(104).bool(message.countable);
    }
    if (message.entryTimingGrade !== 0) {
      writer.uint32(112).int32(message.entryTimingGrade);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawSpatialMetricBlock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawSpatialMetricBlock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.db = DB.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.start = SpatialPosition.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.end = SpatialPosition.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.startLeft = SpatialPosition.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.startRight = SpatialPosition.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.endLeft = SpatialPosition.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.endRight = SpatialPosition.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.opsCenter = JigsawSpatialMetricsOpsCenter.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.companion = JigsawSpatialMetricsCompanion.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.hardwareState = HardwareState.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.BlockWidthMm = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.countable = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.entryTimingGrade = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawSpatialMetricBlock {
    return {
      db: isSet(object.db) ? DB.fromJSON(object.db) : undefined,
      start: isSet(object.start) ? SpatialPosition.fromJSON(object.start) : undefined,
      end: isSet(object.end) ? SpatialPosition.fromJSON(object.end) : undefined,
      startLeft: isSet(object.startLeft)
        ? SpatialPosition.fromJSON(object.startLeft)
        : isSet(object.start_left)
        ? SpatialPosition.fromJSON(object.start_left)
        : undefined,
      startRight: isSet(object.startRight)
        ? SpatialPosition.fromJSON(object.startRight)
        : isSet(object.start_right)
        ? SpatialPosition.fromJSON(object.start_right)
        : undefined,
      endLeft: isSet(object.endLeft)
        ? SpatialPosition.fromJSON(object.endLeft)
        : isSet(object.end_left)
        ? SpatialPosition.fromJSON(object.end_left)
        : undefined,
      endRight: isSet(object.endRight)
        ? SpatialPosition.fromJSON(object.endRight)
        : isSet(object.end_right)
        ? SpatialPosition.fromJSON(object.end_right)
        : undefined,
      opsCenter: isSet(object.opsCenter)
        ? JigsawSpatialMetricsOpsCenter.fromJSON(object.opsCenter)
        : isSet(object.ops_center)
        ? JigsawSpatialMetricsOpsCenter.fromJSON(object.ops_center)
        : undefined,
      companion: isSet(object.companion) ? JigsawSpatialMetricsCompanion.fromJSON(object.companion) : undefined,
      hardwareState: isSet(object.hardwareState)
        ? HardwareState.fromJSON(object.hardwareState)
        : isSet(object.hardware_state)
        ? HardwareState.fromJSON(object.hardware_state)
        : undefined,
      BlockWidthMm: isSet(object.BlockWidthMm) ? globalThis.Number(object.BlockWidthMm) : 0,
      countable: isSet(object.countable) ? globalThis.Boolean(object.countable) : false,
      entryTimingGrade: isSet(object.entryTimingGrade)
        ? entryTimingGradeFromJSON(object.entryTimingGrade)
        : isSet(object.entry_timing_grade)
        ? entryTimingGradeFromJSON(object.entry_timing_grade)
        : 0,
    };
  },

  toJSON(message: JigsawSpatialMetricBlock): unknown {
    const obj: any = {};
    if (message.db !== undefined) {
      obj.db = DB.toJSON(message.db);
    }
    if (message.start !== undefined) {
      obj.start = SpatialPosition.toJSON(message.start);
    }
    if (message.end !== undefined) {
      obj.end = SpatialPosition.toJSON(message.end);
    }
    if (message.startLeft !== undefined) {
      obj.startLeft = SpatialPosition.toJSON(message.startLeft);
    }
    if (message.startRight !== undefined) {
      obj.startRight = SpatialPosition.toJSON(message.startRight);
    }
    if (message.endLeft !== undefined) {
      obj.endLeft = SpatialPosition.toJSON(message.endLeft);
    }
    if (message.endRight !== undefined) {
      obj.endRight = SpatialPosition.toJSON(message.endRight);
    }
    if (message.opsCenter !== undefined) {
      obj.opsCenter = JigsawSpatialMetricsOpsCenter.toJSON(message.opsCenter);
    }
    if (message.companion !== undefined) {
      obj.companion = JigsawSpatialMetricsCompanion.toJSON(message.companion);
    }
    if (message.hardwareState !== undefined) {
      obj.hardwareState = HardwareState.toJSON(message.hardwareState);
    }
    if (message.BlockWidthMm !== 0) {
      obj.BlockWidthMm = Math.round(message.BlockWidthMm);
    }
    if (message.countable !== false) {
      obj.countable = message.countable;
    }
    if (message.entryTimingGrade !== 0) {
      obj.entryTimingGrade = entryTimingGradeToJSON(message.entryTimingGrade);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawSpatialMetricBlock>, I>>(base?: I): JigsawSpatialMetricBlock {
    return JigsawSpatialMetricBlock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawSpatialMetricBlock>, I>>(object: I): JigsawSpatialMetricBlock {
    const message = createBaseJigsawSpatialMetricBlock();
    message.db = (object.db !== undefined && object.db !== null) ? DB.fromPartial(object.db) : undefined;
    message.start = (object.start !== undefined && object.start !== null)
      ? SpatialPosition.fromPartial(object.start)
      : undefined;
    message.end = (object.end !== undefined && object.end !== null)
      ? SpatialPosition.fromPartial(object.end)
      : undefined;
    message.startLeft = (object.startLeft !== undefined && object.startLeft !== null)
      ? SpatialPosition.fromPartial(object.startLeft)
      : undefined;
    message.startRight = (object.startRight !== undefined && object.startRight !== null)
      ? SpatialPosition.fromPartial(object.startRight)
      : undefined;
    message.endLeft = (object.endLeft !== undefined && object.endLeft !== null)
      ? SpatialPosition.fromPartial(object.endLeft)
      : undefined;
    message.endRight = (object.endRight !== undefined && object.endRight !== null)
      ? SpatialPosition.fromPartial(object.endRight)
      : undefined;
    message.opsCenter = (object.opsCenter !== undefined && object.opsCenter !== null)
      ? JigsawSpatialMetricsOpsCenter.fromPartial(object.opsCenter)
      : undefined;
    message.companion = (object.companion !== undefined && object.companion !== null)
      ? JigsawSpatialMetricsCompanion.fromPartial(object.companion)
      : undefined;
    message.hardwareState = (object.hardwareState !== undefined && object.hardwareState !== null)
      ? HardwareState.fromPartial(object.hardwareState)
      : undefined;
    message.BlockWidthMm = object.BlockWidthMm ?? 0;
    message.countable = object.countable ?? false;
    message.entryTimingGrade = object.entryTimingGrade ?? 0;
    return message;
  },
};

function createBaseHardwareState(): HardwareState {
  return {
    eStop: false,
    interlock: false,
    laserKey: false,
    lifted: false,
    waterProtection: false,
    hadCoverage: false,
    wasThinning: false,
    wasWeeding: false,
  };
}

export const HardwareState: MessageFns<HardwareState> = {
  encode(message: HardwareState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eStop !== false) {
      writer.uint32(8).bool(message.eStop);
    }
    if (message.interlock !== false) {
      writer.uint32(16).bool(message.interlock);
    }
    if (message.laserKey !== false) {
      writer.uint32(24).bool(message.laserKey);
    }
    if (message.lifted !== false) {
      writer.uint32(32).bool(message.lifted);
    }
    if (message.waterProtection !== false) {
      writer.uint32(40).bool(message.waterProtection);
    }
    if (message.hadCoverage !== false) {
      writer.uint32(48).bool(message.hadCoverage);
    }
    if (message.wasThinning !== false) {
      writer.uint32(56).bool(message.wasThinning);
    }
    if (message.wasWeeding !== false) {
      writer.uint32(64).bool(message.wasWeeding);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HardwareState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHardwareState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.eStop = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.interlock = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.laserKey = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lifted = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.waterProtection = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.hadCoverage = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.wasThinning = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.wasWeeding = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HardwareState {
    return {
      eStop: isSet(object.eStop)
        ? globalThis.Boolean(object.eStop)
        : isSet(object.e_stop)
        ? globalThis.Boolean(object.e_stop)
        : false,
      interlock: isSet(object.interlock) ? globalThis.Boolean(object.interlock) : false,
      laserKey: isSet(object.laserKey)
        ? globalThis.Boolean(object.laserKey)
        : isSet(object.laser_key)
        ? globalThis.Boolean(object.laser_key)
        : false,
      lifted: isSet(object.lifted) ? globalThis.Boolean(object.lifted) : false,
      waterProtection: isSet(object.waterProtection)
        ? globalThis.Boolean(object.waterProtection)
        : isSet(object.water_protection)
        ? globalThis.Boolean(object.water_protection)
        : false,
      hadCoverage: isSet(object.hadCoverage)
        ? globalThis.Boolean(object.hadCoverage)
        : isSet(object.had_coverage)
        ? globalThis.Boolean(object.had_coverage)
        : false,
      wasThinning: isSet(object.wasThinning)
        ? globalThis.Boolean(object.wasThinning)
        : isSet(object.was_thinning)
        ? globalThis.Boolean(object.was_thinning)
        : false,
      wasWeeding: isSet(object.wasWeeding)
        ? globalThis.Boolean(object.wasWeeding)
        : isSet(object.was_weeding)
        ? globalThis.Boolean(object.was_weeding)
        : false,
    };
  },

  toJSON(message: HardwareState): unknown {
    const obj: any = {};
    if (message.eStop !== false) {
      obj.eStop = message.eStop;
    }
    if (message.interlock !== false) {
      obj.interlock = message.interlock;
    }
    if (message.laserKey !== false) {
      obj.laserKey = message.laserKey;
    }
    if (message.lifted !== false) {
      obj.lifted = message.lifted;
    }
    if (message.waterProtection !== false) {
      obj.waterProtection = message.waterProtection;
    }
    if (message.hadCoverage !== false) {
      obj.hadCoverage = message.hadCoverage;
    }
    if (message.wasThinning !== false) {
      obj.wasThinning = message.wasThinning;
    }
    if (message.wasWeeding !== false) {
      obj.wasWeeding = message.wasWeeding;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HardwareState>, I>>(base?: I): HardwareState {
    return HardwareState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HardwareState>, I>>(object: I): HardwareState {
    const message = createBaseHardwareState();
    message.eStop = object.eStop ?? false;
    message.interlock = object.interlock ?? false;
    message.laserKey = object.laserKey ?? false;
    message.lifted = object.lifted ?? false;
    message.waterProtection = object.waterProtection ?? false;
    message.hadCoverage = object.hadCoverage ?? false;
    message.wasThinning = object.wasThinning ?? false;
    message.wasWeeding = object.wasWeeding ?? false;
    return message;
  },
};

function createBaseOpsCenterSpatialCropMetrics(): OpsCenterSpatialCropMetrics {
  return {
    densityPerSquareMeter: 0,
    averageRadiusMeters: 0,
    found: 0,
    thinned: 0,
    ignored: 0,
    missed: 0,
    kept: 0,
    keptCropDensityPerSqMeter: 0,
    categorySource: 0,
    remainingCropDensityPerSqMeter: 0,
  };
}

export const OpsCenterSpatialCropMetrics: MessageFns<OpsCenterSpatialCropMetrics> = {
  encode(message: OpsCenterSpatialCropMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.densityPerSquareMeter !== 0) {
      writer.uint32(13).float(message.densityPerSquareMeter);
    }
    if (message.averageRadiusMeters !== 0) {
      writer.uint32(21).float(message.averageRadiusMeters);
    }
    if (message.found !== 0) {
      writer.uint32(24).int64(message.found);
    }
    if (message.thinned !== 0) {
      writer.uint32(32).int64(message.thinned);
    }
    if (message.ignored !== 0) {
      writer.uint32(56).int64(message.ignored);
    }
    if (message.missed !== 0) {
      writer.uint32(64).int64(message.missed);
    }
    if (message.kept !== 0) {
      writer.uint32(40).int64(message.kept);
    }
    if (message.keptCropDensityPerSqMeter !== 0) {
      writer.uint32(53).float(message.keptCropDensityPerSqMeter);
    }
    if (message.categorySource !== 0) {
      writer.uint32(72).int32(message.categorySource);
    }
    if (message.remainingCropDensityPerSqMeter !== 0) {
      writer.uint32(85).float(message.remainingCropDensityPerSqMeter);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpsCenterSpatialCropMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpsCenterSpatialCropMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.densityPerSquareMeter = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.averageRadiusMeters = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.found = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.thinned = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ignored = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.missed = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.kept = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.keptCropDensityPerSqMeter = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.categorySource = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.remainingCropDensityPerSqMeter = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpsCenterSpatialCropMetrics {
    return {
      densityPerSquareMeter: isSet(object.densityPerSquareMeter)
        ? globalThis.Number(object.densityPerSquareMeter)
        : isSet(object.density_per_square_meter)
        ? globalThis.Number(object.density_per_square_meter)
        : 0,
      averageRadiusMeters: isSet(object.averageRadiusMeters)
        ? globalThis.Number(object.averageRadiusMeters)
        : isSet(object.average_radius_meters)
        ? globalThis.Number(object.average_radius_meters)
        : 0,
      found: isSet(object.found) ? globalThis.Number(object.found) : 0,
      thinned: isSet(object.thinned) ? globalThis.Number(object.thinned) : 0,
      ignored: isSet(object.ignored) ? globalThis.Number(object.ignored) : 0,
      missed: isSet(object.missed) ? globalThis.Number(object.missed) : 0,
      kept: isSet(object.kept) ? globalThis.Number(object.kept) : 0,
      keptCropDensityPerSqMeter: isSet(object.keptCropDensityPerSqMeter)
        ? globalThis.Number(object.keptCropDensityPerSqMeter)
        : isSet(object.kept_crop_density_per_sq_meter)
        ? globalThis.Number(object.kept_crop_density_per_sq_meter)
        : 0,
      categorySource: isSet(object.categorySource)
        ? categorySourceFromJSON(object.categorySource)
        : isSet(object.category_source)
        ? categorySourceFromJSON(object.category_source)
        : 0,
      remainingCropDensityPerSqMeter: isSet(object.remainingCropDensityPerSqMeter)
        ? globalThis.Number(object.remainingCropDensityPerSqMeter)
        : isSet(object.remaining_crop_density_per_sq_meter)
        ? globalThis.Number(object.remaining_crop_density_per_sq_meter)
        : 0,
    };
  },

  toJSON(message: OpsCenterSpatialCropMetrics): unknown {
    const obj: any = {};
    if (message.densityPerSquareMeter !== 0) {
      obj.densityPerSquareMeter = message.densityPerSquareMeter;
    }
    if (message.averageRadiusMeters !== 0) {
      obj.averageRadiusMeters = message.averageRadiusMeters;
    }
    if (message.found !== 0) {
      obj.found = Math.round(message.found);
    }
    if (message.thinned !== 0) {
      obj.thinned = Math.round(message.thinned);
    }
    if (message.ignored !== 0) {
      obj.ignored = Math.round(message.ignored);
    }
    if (message.missed !== 0) {
      obj.missed = Math.round(message.missed);
    }
    if (message.kept !== 0) {
      obj.kept = Math.round(message.kept);
    }
    if (message.keptCropDensityPerSqMeter !== 0) {
      obj.keptCropDensityPerSqMeter = message.keptCropDensityPerSqMeter;
    }
    if (message.categorySource !== 0) {
      obj.categorySource = categorySourceToJSON(message.categorySource);
    }
    if (message.remainingCropDensityPerSqMeter !== 0) {
      obj.remainingCropDensityPerSqMeter = message.remainingCropDensityPerSqMeter;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpsCenterSpatialCropMetrics>, I>>(base?: I): OpsCenterSpatialCropMetrics {
    return OpsCenterSpatialCropMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpsCenterSpatialCropMetrics>, I>>(object: I): OpsCenterSpatialCropMetrics {
    const message = createBaseOpsCenterSpatialCropMetrics();
    message.densityPerSquareMeter = object.densityPerSquareMeter ?? 0;
    message.averageRadiusMeters = object.averageRadiusMeters ?? 0;
    message.found = object.found ?? 0;
    message.thinned = object.thinned ?? 0;
    message.ignored = object.ignored ?? 0;
    message.missed = object.missed ?? 0;
    message.kept = object.kept ?? 0;
    message.keptCropDensityPerSqMeter = object.keptCropDensityPerSqMeter ?? 0;
    message.categorySource = object.categorySource ?? 0;
    message.remainingCropDensityPerSqMeter = object.remainingCropDensityPerSqMeter ?? 0;
    return message;
  },
};

function createBaseOpsCenterSpatialWeedMetrics(): OpsCenterSpatialWeedMetrics {
  return { fractionOfTotal: 0, categorySource: 0 };
}

export const OpsCenterSpatialWeedMetrics: MessageFns<OpsCenterSpatialWeedMetrics> = {
  encode(message: OpsCenterSpatialWeedMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fractionOfTotal !== 0) {
      writer.uint32(13).float(message.fractionOfTotal);
    }
    if (message.categorySource !== 0) {
      writer.uint32(16).int32(message.categorySource);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpsCenterSpatialWeedMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOpsCenterSpatialWeedMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.fractionOfTotal = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.categorySource = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OpsCenterSpatialWeedMetrics {
    return {
      fractionOfTotal: isSet(object.fractionOfTotal)
        ? globalThis.Number(object.fractionOfTotal)
        : isSet(object.fraction_of_total)
        ? globalThis.Number(object.fraction_of_total)
        : 0,
      categorySource: isSet(object.categorySource)
        ? categorySourceFromJSON(object.categorySource)
        : isSet(object.category_source)
        ? categorySourceFromJSON(object.category_source)
        : 0,
    };
  },

  toJSON(message: OpsCenterSpatialWeedMetrics): unknown {
    const obj: any = {};
    if (message.fractionOfTotal !== 0) {
      obj.fractionOfTotal = message.fractionOfTotal;
    }
    if (message.categorySource !== 0) {
      obj.categorySource = categorySourceToJSON(message.categorySource);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OpsCenterSpatialWeedMetrics>, I>>(base?: I): OpsCenterSpatialWeedMetrics {
    return OpsCenterSpatialWeedMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OpsCenterSpatialWeedMetrics>, I>>(object: I): OpsCenterSpatialWeedMetrics {
    const message = createBaseOpsCenterSpatialWeedMetrics();
    message.fractionOfTotal = object.fractionOfTotal ?? 0;
    message.categorySource = object.categorySource ?? 0;
    return message;
  },
};

function createBaseJigsawSpatialMetricsOpsCenter(): JigsawSpatialMetricsOpsCenter {
  return {
    averageCropRadiusMeters: 0,
    averageShootTimeSeconds: 0,
    averageTargetSpeedMetersPerSecond: 0,
    averageTravelSpeedMetersPerSecond: 0,
    averageWeedRadiusMeters: 0,
    coverageSquareMeters: 0,
    cropDensityPerSqMeter: 0,
    cropsFound: 0,
    cropsIgnored: 0,
    cropsKept: 0,
    cropsMissed: 0,
    cropsThinned: 0,
    keptCropDensityPerSqMeter: 0,
    overallPerformance: 0,
    percentWeedsBroadleaf: 0,
    percentWeedsDisregard: 0,
    percentWeedsGrass: 0,
    percentWeedsOffshoot: 0,
    percentWeedsPurslane: 0,
    percentageBanded: 0,
    targetSpeedRatio: 0,
    thinningPerformance: 0,
    weedDensityPerSqMeter: 0,
    weedingPerformance: 0,
    weedsFound: 0,
    weedsIgnored: 0,
    weedsInBand: 0,
    weedsKilled: 0,
    weedsMissed: 0,
    cropMetrics: {},
    weedMetrics: {},
    bandedAreaFraction: 0,
    remainingCropDensityPerSqMeter: 0,
  };
}

export const JigsawSpatialMetricsOpsCenter: MessageFns<JigsawSpatialMetricsOpsCenter> = {
  encode(message: JigsawSpatialMetricsOpsCenter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.averageCropRadiusMeters !== 0) {
      writer.uint32(13).float(message.averageCropRadiusMeters);
    }
    if (message.averageShootTimeSeconds !== 0) {
      writer.uint32(21).float(message.averageShootTimeSeconds);
    }
    if (message.averageTargetSpeedMetersPerSecond !== 0) {
      writer.uint32(29).float(message.averageTargetSpeedMetersPerSecond);
    }
    if (message.averageTravelSpeedMetersPerSecond !== 0) {
      writer.uint32(37).float(message.averageTravelSpeedMetersPerSecond);
    }
    if (message.averageWeedRadiusMeters !== 0) {
      writer.uint32(45).float(message.averageWeedRadiusMeters);
    }
    if (message.coverageSquareMeters !== 0) {
      writer.uint32(53).float(message.coverageSquareMeters);
    }
    if (message.cropDensityPerSqMeter !== 0) {
      writer.uint32(61).float(message.cropDensityPerSqMeter);
    }
    if (message.cropsFound !== 0) {
      writer.uint32(64).int64(message.cropsFound);
    }
    if (message.cropsIgnored !== 0) {
      writer.uint32(72).int64(message.cropsIgnored);
    }
    if (message.cropsKept !== 0) {
      writer.uint32(80).int64(message.cropsKept);
    }
    if (message.cropsMissed !== 0) {
      writer.uint32(88).int64(message.cropsMissed);
    }
    if (message.cropsThinned !== 0) {
      writer.uint32(96).int64(message.cropsThinned);
    }
    if (message.keptCropDensityPerSqMeter !== 0) {
      writer.uint32(109).float(message.keptCropDensityPerSqMeter);
    }
    if (message.overallPerformance !== 0) {
      writer.uint32(117).float(message.overallPerformance);
    }
    if (message.percentWeedsBroadleaf !== 0) {
      writer.uint32(125).float(message.percentWeedsBroadleaf);
    }
    if (message.percentWeedsDisregard !== 0) {
      writer.uint32(133).float(message.percentWeedsDisregard);
    }
    if (message.percentWeedsGrass !== 0) {
      writer.uint32(141).float(message.percentWeedsGrass);
    }
    if (message.percentWeedsOffshoot !== 0) {
      writer.uint32(149).float(message.percentWeedsOffshoot);
    }
    if (message.percentWeedsPurslane !== 0) {
      writer.uint32(157).float(message.percentWeedsPurslane);
    }
    if (message.percentageBanded !== 0) {
      writer.uint32(165).float(message.percentageBanded);
    }
    if (message.targetSpeedRatio !== 0) {
      writer.uint32(173).float(message.targetSpeedRatio);
    }
    if (message.thinningPerformance !== 0) {
      writer.uint32(181).float(message.thinningPerformance);
    }
    if (message.weedDensityPerSqMeter !== 0) {
      writer.uint32(189).float(message.weedDensityPerSqMeter);
    }
    if (message.weedingPerformance !== 0) {
      writer.uint32(197).float(message.weedingPerformance);
    }
    if (message.weedsFound !== 0) {
      writer.uint32(200).int64(message.weedsFound);
    }
    if (message.weedsIgnored !== 0) {
      writer.uint32(208).int64(message.weedsIgnored);
    }
    if (message.weedsInBand !== 0) {
      writer.uint32(216).int64(message.weedsInBand);
    }
    if (message.weedsKilled !== 0) {
      writer.uint32(224).int64(message.weedsKilled);
    }
    if (message.weedsMissed !== 0) {
      writer.uint32(232).int64(message.weedsMissed);
    }
    globalThis.Object.entries(message.cropMetrics).forEach(([key, value]: [string, OpsCenterSpatialCropMetrics]) => {
      JigsawSpatialMetricsOpsCenter_CropMetricsEntry.encode({ key: key as any, value }, writer.uint32(242).fork())
        .join();
    });
    globalThis.Object.entries(message.weedMetrics).forEach(([key, value]: [string, OpsCenterSpatialWeedMetrics]) => {
      JigsawSpatialMetricsOpsCenter_WeedMetricsEntry.encode({ key: key as any, value }, writer.uint32(250).fork())
        .join();
    });
    if (message.bandedAreaFraction !== 0) {
      writer.uint32(261).float(message.bandedAreaFraction);
    }
    if (message.remainingCropDensityPerSqMeter !== 0) {
      writer.uint32(269).float(message.remainingCropDensityPerSqMeter);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawSpatialMetricsOpsCenter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawSpatialMetricsOpsCenter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.averageCropRadiusMeters = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.averageShootTimeSeconds = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.averageTargetSpeedMetersPerSecond = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.averageTravelSpeedMetersPerSecond = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.averageWeedRadiusMeters = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.coverageSquareMeters = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.cropDensityPerSqMeter = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cropsFound = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.cropsIgnored = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.cropsKept = longToNumber(reader.int64());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.cropsMissed = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.cropsThinned = longToNumber(reader.int64());
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.keptCropDensityPerSqMeter = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.overallPerformance = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.percentWeedsBroadleaf = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.percentWeedsDisregard = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 141) {
            break;
          }

          message.percentWeedsGrass = reader.float();
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.percentWeedsOffshoot = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.percentWeedsPurslane = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.percentageBanded = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.targetSpeedRatio = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 181) {
            break;
          }

          message.thinningPerformance = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 189) {
            break;
          }

          message.weedDensityPerSqMeter = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 197) {
            break;
          }

          message.weedingPerformance = reader.float();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.weedsFound = longToNumber(reader.int64());
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.weedsIgnored = longToNumber(reader.int64());
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.weedsInBand = longToNumber(reader.int64());
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.weedsKilled = longToNumber(reader.int64());
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.weedsMissed = longToNumber(reader.int64());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          const entry30 = JigsawSpatialMetricsOpsCenter_CropMetricsEntry.decode(reader, reader.uint32());
          if (entry30.value !== undefined) {
            message.cropMetrics[entry30.key] = entry30.value;
          }
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          const entry31 = JigsawSpatialMetricsOpsCenter_WeedMetricsEntry.decode(reader, reader.uint32());
          if (entry31.value !== undefined) {
            message.weedMetrics[entry31.key] = entry31.value;
          }
          continue;
        }
        case 32: {
          if (tag !== 261) {
            break;
          }

          message.bandedAreaFraction = reader.float();
          continue;
        }
        case 33: {
          if (tag !== 269) {
            break;
          }

          message.remainingCropDensityPerSqMeter = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawSpatialMetricsOpsCenter {
    return {
      averageCropRadiusMeters: isSet(object.averageCropRadiusMeters)
        ? globalThis.Number(object.averageCropRadiusMeters)
        : isSet(object.average_crop_radius_meters)
        ? globalThis.Number(object.average_crop_radius_meters)
        : 0,
      averageShootTimeSeconds: isSet(object.averageShootTimeSeconds)
        ? globalThis.Number(object.averageShootTimeSeconds)
        : isSet(object.average_shoot_time_seconds)
        ? globalThis.Number(object.average_shoot_time_seconds)
        : 0,
      averageTargetSpeedMetersPerSecond: isSet(object.averageTargetSpeedMetersPerSecond)
        ? globalThis.Number(object.averageTargetSpeedMetersPerSecond)
        : isSet(object.average_target_speed_meters_per_second)
        ? globalThis.Number(object.average_target_speed_meters_per_second)
        : 0,
      averageTravelSpeedMetersPerSecond: isSet(object.averageTravelSpeedMetersPerSecond)
        ? globalThis.Number(object.averageTravelSpeedMetersPerSecond)
        : isSet(object.average_travel_speed_meters_per_second)
        ? globalThis.Number(object.average_travel_speed_meters_per_second)
        : 0,
      averageWeedRadiusMeters: isSet(object.averageWeedRadiusMeters)
        ? globalThis.Number(object.averageWeedRadiusMeters)
        : isSet(object.average_weed_radius_meters)
        ? globalThis.Number(object.average_weed_radius_meters)
        : 0,
      coverageSquareMeters: isSet(object.coverageSquareMeters)
        ? globalThis.Number(object.coverageSquareMeters)
        : isSet(object.coverage_square_meters)
        ? globalThis.Number(object.coverage_square_meters)
        : 0,
      cropDensityPerSqMeter: isSet(object.cropDensityPerSqMeter)
        ? globalThis.Number(object.cropDensityPerSqMeter)
        : isSet(object.crop_density_per_sq_meter)
        ? globalThis.Number(object.crop_density_per_sq_meter)
        : 0,
      cropsFound: isSet(object.cropsFound)
        ? globalThis.Number(object.cropsFound)
        : isSet(object.crops_found)
        ? globalThis.Number(object.crops_found)
        : 0,
      cropsIgnored: isSet(object.cropsIgnored)
        ? globalThis.Number(object.cropsIgnored)
        : isSet(object.crops_ignored)
        ? globalThis.Number(object.crops_ignored)
        : 0,
      cropsKept: isSet(object.cropsKept)
        ? globalThis.Number(object.cropsKept)
        : isSet(object.crops_kept)
        ? globalThis.Number(object.crops_kept)
        : 0,
      cropsMissed: isSet(object.cropsMissed)
        ? globalThis.Number(object.cropsMissed)
        : isSet(object.crops_missed)
        ? globalThis.Number(object.crops_missed)
        : 0,
      cropsThinned: isSet(object.cropsThinned)
        ? globalThis.Number(object.cropsThinned)
        : isSet(object.crops_thinned)
        ? globalThis.Number(object.crops_thinned)
        : 0,
      keptCropDensityPerSqMeter: isSet(object.keptCropDensityPerSqMeter)
        ? globalThis.Number(object.keptCropDensityPerSqMeter)
        : isSet(object.kept_crop_density_per_sq_meter)
        ? globalThis.Number(object.kept_crop_density_per_sq_meter)
        : 0,
      overallPerformance: isSet(object.overallPerformance)
        ? globalThis.Number(object.overallPerformance)
        : isSet(object.overall_performance)
        ? globalThis.Number(object.overall_performance)
        : 0,
      percentWeedsBroadleaf: isSet(object.percentWeedsBroadleaf)
        ? globalThis.Number(object.percentWeedsBroadleaf)
        : isSet(object.percent_weeds_broadleaf)
        ? globalThis.Number(object.percent_weeds_broadleaf)
        : 0,
      percentWeedsDisregard: isSet(object.percentWeedsDisregard)
        ? globalThis.Number(object.percentWeedsDisregard)
        : isSet(object.percent_weeds_disregard)
        ? globalThis.Number(object.percent_weeds_disregard)
        : 0,
      percentWeedsGrass: isSet(object.percentWeedsGrass)
        ? globalThis.Number(object.percentWeedsGrass)
        : isSet(object.percent_weeds_grass)
        ? globalThis.Number(object.percent_weeds_grass)
        : 0,
      percentWeedsOffshoot: isSet(object.percentWeedsOffshoot)
        ? globalThis.Number(object.percentWeedsOffshoot)
        : isSet(object.percent_weeds_offshoot)
        ? globalThis.Number(object.percent_weeds_offshoot)
        : 0,
      percentWeedsPurslane: isSet(object.percentWeedsPurslane)
        ? globalThis.Number(object.percentWeedsPurslane)
        : isSet(object.percent_weeds_purslane)
        ? globalThis.Number(object.percent_weeds_purslane)
        : 0,
      percentageBanded: isSet(object.percentageBanded)
        ? globalThis.Number(object.percentageBanded)
        : isSet(object.percentage_banded)
        ? globalThis.Number(object.percentage_banded)
        : 0,
      targetSpeedRatio: isSet(object.targetSpeedRatio)
        ? globalThis.Number(object.targetSpeedRatio)
        : isSet(object.target_speed_ratio)
        ? globalThis.Number(object.target_speed_ratio)
        : 0,
      thinningPerformance: isSet(object.thinningPerformance)
        ? globalThis.Number(object.thinningPerformance)
        : isSet(object.thinning_performance)
        ? globalThis.Number(object.thinning_performance)
        : 0,
      weedDensityPerSqMeter: isSet(object.weedDensityPerSqMeter)
        ? globalThis.Number(object.weedDensityPerSqMeter)
        : isSet(object.weed_density_per_sq_meter)
        ? globalThis.Number(object.weed_density_per_sq_meter)
        : 0,
      weedingPerformance: isSet(object.weedingPerformance)
        ? globalThis.Number(object.weedingPerformance)
        : isSet(object.weeding_performance)
        ? globalThis.Number(object.weeding_performance)
        : 0,
      weedsFound: isSet(object.weedsFound)
        ? globalThis.Number(object.weedsFound)
        : isSet(object.weeds_found)
        ? globalThis.Number(object.weeds_found)
        : 0,
      weedsIgnored: isSet(object.weedsIgnored)
        ? globalThis.Number(object.weedsIgnored)
        : isSet(object.weeds_ignored)
        ? globalThis.Number(object.weeds_ignored)
        : 0,
      weedsInBand: isSet(object.weedsInBand)
        ? globalThis.Number(object.weedsInBand)
        : isSet(object.weeds_in_band)
        ? globalThis.Number(object.weeds_in_band)
        : 0,
      weedsKilled: isSet(object.weedsKilled)
        ? globalThis.Number(object.weedsKilled)
        : isSet(object.weeds_killed)
        ? globalThis.Number(object.weeds_killed)
        : 0,
      weedsMissed: isSet(object.weedsMissed)
        ? globalThis.Number(object.weedsMissed)
        : isSet(object.weeds_missed)
        ? globalThis.Number(object.weeds_missed)
        : 0,
      cropMetrics: isObject(object.cropMetrics)
        ? (globalThis.Object.entries(object.cropMetrics) as [string, any][]).reduce(
          (acc: { [key: string]: OpsCenterSpatialCropMetrics }, [key, value]: [string, any]) => {
            acc[key] = OpsCenterSpatialCropMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.crop_metrics)
        ? (globalThis.Object.entries(object.crop_metrics) as [string, any][]).reduce(
          (acc: { [key: string]: OpsCenterSpatialCropMetrics }, [key, value]: [string, any]) => {
            acc[key] = OpsCenterSpatialCropMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      weedMetrics: isObject(object.weedMetrics)
        ? (globalThis.Object.entries(object.weedMetrics) as [string, any][]).reduce(
          (acc: { [key: string]: OpsCenterSpatialWeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = OpsCenterSpatialWeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.weed_metrics)
        ? (globalThis.Object.entries(object.weed_metrics) as [string, any][]).reduce(
          (acc: { [key: string]: OpsCenterSpatialWeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = OpsCenterSpatialWeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      bandedAreaFraction: isSet(object.bandedAreaFraction)
        ? globalThis.Number(object.bandedAreaFraction)
        : isSet(object.banded_area_fraction)
        ? globalThis.Number(object.banded_area_fraction)
        : 0,
      remainingCropDensityPerSqMeter: isSet(object.remainingCropDensityPerSqMeter)
        ? globalThis.Number(object.remainingCropDensityPerSqMeter)
        : isSet(object.remaining_crop_density_per_sq_meter)
        ? globalThis.Number(object.remaining_crop_density_per_sq_meter)
        : 0,
    };
  },

  toJSON(message: JigsawSpatialMetricsOpsCenter): unknown {
    const obj: any = {};
    if (message.averageCropRadiusMeters !== 0) {
      obj.averageCropRadiusMeters = message.averageCropRadiusMeters;
    }
    if (message.averageShootTimeSeconds !== 0) {
      obj.averageShootTimeSeconds = message.averageShootTimeSeconds;
    }
    if (message.averageTargetSpeedMetersPerSecond !== 0) {
      obj.averageTargetSpeedMetersPerSecond = message.averageTargetSpeedMetersPerSecond;
    }
    if (message.averageTravelSpeedMetersPerSecond !== 0) {
      obj.averageTravelSpeedMetersPerSecond = message.averageTravelSpeedMetersPerSecond;
    }
    if (message.averageWeedRadiusMeters !== 0) {
      obj.averageWeedRadiusMeters = message.averageWeedRadiusMeters;
    }
    if (message.coverageSquareMeters !== 0) {
      obj.coverageSquareMeters = message.coverageSquareMeters;
    }
    if (message.cropDensityPerSqMeter !== 0) {
      obj.cropDensityPerSqMeter = message.cropDensityPerSqMeter;
    }
    if (message.cropsFound !== 0) {
      obj.cropsFound = Math.round(message.cropsFound);
    }
    if (message.cropsIgnored !== 0) {
      obj.cropsIgnored = Math.round(message.cropsIgnored);
    }
    if (message.cropsKept !== 0) {
      obj.cropsKept = Math.round(message.cropsKept);
    }
    if (message.cropsMissed !== 0) {
      obj.cropsMissed = Math.round(message.cropsMissed);
    }
    if (message.cropsThinned !== 0) {
      obj.cropsThinned = Math.round(message.cropsThinned);
    }
    if (message.keptCropDensityPerSqMeter !== 0) {
      obj.keptCropDensityPerSqMeter = message.keptCropDensityPerSqMeter;
    }
    if (message.overallPerformance !== 0) {
      obj.overallPerformance = message.overallPerformance;
    }
    if (message.percentWeedsBroadleaf !== 0) {
      obj.percentWeedsBroadleaf = message.percentWeedsBroadleaf;
    }
    if (message.percentWeedsDisregard !== 0) {
      obj.percentWeedsDisregard = message.percentWeedsDisregard;
    }
    if (message.percentWeedsGrass !== 0) {
      obj.percentWeedsGrass = message.percentWeedsGrass;
    }
    if (message.percentWeedsOffshoot !== 0) {
      obj.percentWeedsOffshoot = message.percentWeedsOffshoot;
    }
    if (message.percentWeedsPurslane !== 0) {
      obj.percentWeedsPurslane = message.percentWeedsPurslane;
    }
    if (message.percentageBanded !== 0) {
      obj.percentageBanded = message.percentageBanded;
    }
    if (message.targetSpeedRatio !== 0) {
      obj.targetSpeedRatio = message.targetSpeedRatio;
    }
    if (message.thinningPerformance !== 0) {
      obj.thinningPerformance = message.thinningPerformance;
    }
    if (message.weedDensityPerSqMeter !== 0) {
      obj.weedDensityPerSqMeter = message.weedDensityPerSqMeter;
    }
    if (message.weedingPerformance !== 0) {
      obj.weedingPerformance = message.weedingPerformance;
    }
    if (message.weedsFound !== 0) {
      obj.weedsFound = Math.round(message.weedsFound);
    }
    if (message.weedsIgnored !== 0) {
      obj.weedsIgnored = Math.round(message.weedsIgnored);
    }
    if (message.weedsInBand !== 0) {
      obj.weedsInBand = Math.round(message.weedsInBand);
    }
    if (message.weedsKilled !== 0) {
      obj.weedsKilled = Math.round(message.weedsKilled);
    }
    if (message.weedsMissed !== 0) {
      obj.weedsMissed = Math.round(message.weedsMissed);
    }
    if (message.cropMetrics) {
      const entries = globalThis.Object.entries(message.cropMetrics) as [string, OpsCenterSpatialCropMetrics][];
      if (entries.length > 0) {
        obj.cropMetrics = {};
        entries.forEach(([k, v]) => {
          obj.cropMetrics[k] = OpsCenterSpatialCropMetrics.toJSON(v);
        });
      }
    }
    if (message.weedMetrics) {
      const entries = globalThis.Object.entries(message.weedMetrics) as [string, OpsCenterSpatialWeedMetrics][];
      if (entries.length > 0) {
        obj.weedMetrics = {};
        entries.forEach(([k, v]) => {
          obj.weedMetrics[k] = OpsCenterSpatialWeedMetrics.toJSON(v);
        });
      }
    }
    if (message.bandedAreaFraction !== 0) {
      obj.bandedAreaFraction = message.bandedAreaFraction;
    }
    if (message.remainingCropDensityPerSqMeter !== 0) {
      obj.remainingCropDensityPerSqMeter = message.remainingCropDensityPerSqMeter;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawSpatialMetricsOpsCenter>, I>>(base?: I): JigsawSpatialMetricsOpsCenter {
    return JigsawSpatialMetricsOpsCenter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawSpatialMetricsOpsCenter>, I>>(
    object: I,
  ): JigsawSpatialMetricsOpsCenter {
    const message = createBaseJigsawSpatialMetricsOpsCenter();
    message.averageCropRadiusMeters = object.averageCropRadiusMeters ?? 0;
    message.averageShootTimeSeconds = object.averageShootTimeSeconds ?? 0;
    message.averageTargetSpeedMetersPerSecond = object.averageTargetSpeedMetersPerSecond ?? 0;
    message.averageTravelSpeedMetersPerSecond = object.averageTravelSpeedMetersPerSecond ?? 0;
    message.averageWeedRadiusMeters = object.averageWeedRadiusMeters ?? 0;
    message.coverageSquareMeters = object.coverageSquareMeters ?? 0;
    message.cropDensityPerSqMeter = object.cropDensityPerSqMeter ?? 0;
    message.cropsFound = object.cropsFound ?? 0;
    message.cropsIgnored = object.cropsIgnored ?? 0;
    message.cropsKept = object.cropsKept ?? 0;
    message.cropsMissed = object.cropsMissed ?? 0;
    message.cropsThinned = object.cropsThinned ?? 0;
    message.keptCropDensityPerSqMeter = object.keptCropDensityPerSqMeter ?? 0;
    message.overallPerformance = object.overallPerformance ?? 0;
    message.percentWeedsBroadleaf = object.percentWeedsBroadleaf ?? 0;
    message.percentWeedsDisregard = object.percentWeedsDisregard ?? 0;
    message.percentWeedsGrass = object.percentWeedsGrass ?? 0;
    message.percentWeedsOffshoot = object.percentWeedsOffshoot ?? 0;
    message.percentWeedsPurslane = object.percentWeedsPurslane ?? 0;
    message.percentageBanded = object.percentageBanded ?? 0;
    message.targetSpeedRatio = object.targetSpeedRatio ?? 0;
    message.thinningPerformance = object.thinningPerformance ?? 0;
    message.weedDensityPerSqMeter = object.weedDensityPerSqMeter ?? 0;
    message.weedingPerformance = object.weedingPerformance ?? 0;
    message.weedsFound = object.weedsFound ?? 0;
    message.weedsIgnored = object.weedsIgnored ?? 0;
    message.weedsInBand = object.weedsInBand ?? 0;
    message.weedsKilled = object.weedsKilled ?? 0;
    message.weedsMissed = object.weedsMissed ?? 0;
    message.cropMetrics =
      (globalThis.Object.entries(object.cropMetrics ?? {}) as [string, OpsCenterSpatialCropMetrics][]).reduce(
        (acc: { [key: string]: OpsCenterSpatialCropMetrics }, [key, value]: [string, OpsCenterSpatialCropMetrics]) => {
          if (value !== undefined) {
            acc[key] = OpsCenterSpatialCropMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.weedMetrics =
      (globalThis.Object.entries(object.weedMetrics ?? {}) as [string, OpsCenterSpatialWeedMetrics][]).reduce(
        (acc: { [key: string]: OpsCenterSpatialWeedMetrics }, [key, value]: [string, OpsCenterSpatialWeedMetrics]) => {
          if (value !== undefined) {
            acc[key] = OpsCenterSpatialWeedMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.bandedAreaFraction = object.bandedAreaFraction ?? 0;
    message.remainingCropDensityPerSqMeter = object.remainingCropDensityPerSqMeter ?? 0;
    return message;
  },
};

function createBaseJigsawSpatialMetricsOpsCenter_CropMetricsEntry(): JigsawSpatialMetricsOpsCenter_CropMetricsEntry {
  return { key: "", value: undefined };
}

export const JigsawSpatialMetricsOpsCenter_CropMetricsEntry: MessageFns<
  JigsawSpatialMetricsOpsCenter_CropMetricsEntry
> = {
  encode(
    message: JigsawSpatialMetricsOpsCenter_CropMetricsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      OpsCenterSpatialCropMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawSpatialMetricsOpsCenter_CropMetricsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawSpatialMetricsOpsCenter_CropMetricsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = OpsCenterSpatialCropMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawSpatialMetricsOpsCenter_CropMetricsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? OpsCenterSpatialCropMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: JigsawSpatialMetricsOpsCenter_CropMetricsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = OpsCenterSpatialCropMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawSpatialMetricsOpsCenter_CropMetricsEntry>, I>>(
    base?: I,
  ): JigsawSpatialMetricsOpsCenter_CropMetricsEntry {
    return JigsawSpatialMetricsOpsCenter_CropMetricsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawSpatialMetricsOpsCenter_CropMetricsEntry>, I>>(
    object: I,
  ): JigsawSpatialMetricsOpsCenter_CropMetricsEntry {
    const message = createBaseJigsawSpatialMetricsOpsCenter_CropMetricsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? OpsCenterSpatialCropMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseJigsawSpatialMetricsOpsCenter_WeedMetricsEntry(): JigsawSpatialMetricsOpsCenter_WeedMetricsEntry {
  return { key: "", value: undefined };
}

export const JigsawSpatialMetricsOpsCenter_WeedMetricsEntry: MessageFns<
  JigsawSpatialMetricsOpsCenter_WeedMetricsEntry
> = {
  encode(
    message: JigsawSpatialMetricsOpsCenter_WeedMetricsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      OpsCenterSpatialWeedMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawSpatialMetricsOpsCenter_WeedMetricsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawSpatialMetricsOpsCenter_WeedMetricsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = OpsCenterSpatialWeedMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawSpatialMetricsOpsCenter_WeedMetricsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? OpsCenterSpatialWeedMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: JigsawSpatialMetricsOpsCenter_WeedMetricsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = OpsCenterSpatialWeedMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawSpatialMetricsOpsCenter_WeedMetricsEntry>, I>>(
    base?: I,
  ): JigsawSpatialMetricsOpsCenter_WeedMetricsEntry {
    return JigsawSpatialMetricsOpsCenter_WeedMetricsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawSpatialMetricsOpsCenter_WeedMetricsEntry>, I>>(
    object: I,
  ): JigsawSpatialMetricsOpsCenter_WeedMetricsEntry {
    const message = createBaseJigsawSpatialMetricsOpsCenter_WeedMetricsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? OpsCenterSpatialWeedMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseJigsawSpatialMetricsCompanion(): JigsawSpatialMetricsCompanion {
  return {
    averageCropRadiusMeters: 0,
    averageTravelSpeedMetersPerSecond: 0,
    averageWeedRadiusMeters: 0,
    coverageSquareMeters: 0,
    cropDensityPerSqMeter: 0,
    keptCropDensityPerSqMeter: 0,
    overallPerformance: 0,
    percentWeedsBroadleaf: 0,
    percentWeedsDisregard: 0,
    percentWeedsGrass: 0,
    percentWeedsOffshoot: 0,
    percentWeedsPurslane: 0,
    thinningPerformance: 0,
    weedDensityPerSqMeter: 0,
    weedingPerformance: 0,
    remainingCropDensityPerSqMeter: 0,
  };
}

export const JigsawSpatialMetricsCompanion: MessageFns<JigsawSpatialMetricsCompanion> = {
  encode(message: JigsawSpatialMetricsCompanion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.averageCropRadiusMeters !== 0) {
      writer.uint32(13).float(message.averageCropRadiusMeters);
    }
    if (message.averageTravelSpeedMetersPerSecond !== 0) {
      writer.uint32(21).float(message.averageTravelSpeedMetersPerSecond);
    }
    if (message.averageWeedRadiusMeters !== 0) {
      writer.uint32(29).float(message.averageWeedRadiusMeters);
    }
    if (message.coverageSquareMeters !== 0) {
      writer.uint32(37).float(message.coverageSquareMeters);
    }
    if (message.cropDensityPerSqMeter !== 0) {
      writer.uint32(45).float(message.cropDensityPerSqMeter);
    }
    if (message.keptCropDensityPerSqMeter !== 0) {
      writer.uint32(53).float(message.keptCropDensityPerSqMeter);
    }
    if (message.overallPerformance !== 0) {
      writer.uint32(61).float(message.overallPerformance);
    }
    if (message.percentWeedsBroadleaf !== 0) {
      writer.uint32(69).float(message.percentWeedsBroadleaf);
    }
    if (message.percentWeedsDisregard !== 0) {
      writer.uint32(77).float(message.percentWeedsDisregard);
    }
    if (message.percentWeedsGrass !== 0) {
      writer.uint32(85).float(message.percentWeedsGrass);
    }
    if (message.percentWeedsOffshoot !== 0) {
      writer.uint32(93).float(message.percentWeedsOffshoot);
    }
    if (message.percentWeedsPurslane !== 0) {
      writer.uint32(101).float(message.percentWeedsPurslane);
    }
    if (message.thinningPerformance !== 0) {
      writer.uint32(109).float(message.thinningPerformance);
    }
    if (message.weedDensityPerSqMeter !== 0) {
      writer.uint32(117).float(message.weedDensityPerSqMeter);
    }
    if (message.weedingPerformance !== 0) {
      writer.uint32(125).float(message.weedingPerformance);
    }
    if (message.remainingCropDensityPerSqMeter !== 0) {
      writer.uint32(133).float(message.remainingCropDensityPerSqMeter);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawSpatialMetricsCompanion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawSpatialMetricsCompanion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.averageCropRadiusMeters = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.averageTravelSpeedMetersPerSecond = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.averageWeedRadiusMeters = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.coverageSquareMeters = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.cropDensityPerSqMeter = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.keptCropDensityPerSqMeter = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.overallPerformance = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.percentWeedsBroadleaf = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.percentWeedsDisregard = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.percentWeedsGrass = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.percentWeedsOffshoot = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.percentWeedsPurslane = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.thinningPerformance = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.weedDensityPerSqMeter = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.weedingPerformance = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.remainingCropDensityPerSqMeter = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawSpatialMetricsCompanion {
    return {
      averageCropRadiusMeters: isSet(object.averageCropRadiusMeters)
        ? globalThis.Number(object.averageCropRadiusMeters)
        : isSet(object.average_crop_radius_meters)
        ? globalThis.Number(object.average_crop_radius_meters)
        : 0,
      averageTravelSpeedMetersPerSecond: isSet(object.averageTravelSpeedMetersPerSecond)
        ? globalThis.Number(object.averageTravelSpeedMetersPerSecond)
        : isSet(object.average_travel_speed_meters_per_second)
        ? globalThis.Number(object.average_travel_speed_meters_per_second)
        : 0,
      averageWeedRadiusMeters: isSet(object.averageWeedRadiusMeters)
        ? globalThis.Number(object.averageWeedRadiusMeters)
        : isSet(object.average_weed_radius_meters)
        ? globalThis.Number(object.average_weed_radius_meters)
        : 0,
      coverageSquareMeters: isSet(object.coverageSquareMeters)
        ? globalThis.Number(object.coverageSquareMeters)
        : isSet(object.coverage_square_meters)
        ? globalThis.Number(object.coverage_square_meters)
        : 0,
      cropDensityPerSqMeter: isSet(object.cropDensityPerSqMeter)
        ? globalThis.Number(object.cropDensityPerSqMeter)
        : isSet(object.crop_density_per_sq_meter)
        ? globalThis.Number(object.crop_density_per_sq_meter)
        : 0,
      keptCropDensityPerSqMeter: isSet(object.keptCropDensityPerSqMeter)
        ? globalThis.Number(object.keptCropDensityPerSqMeter)
        : isSet(object.kept_crop_density_per_sq_meter)
        ? globalThis.Number(object.kept_crop_density_per_sq_meter)
        : 0,
      overallPerformance: isSet(object.overallPerformance)
        ? globalThis.Number(object.overallPerformance)
        : isSet(object.overall_performance)
        ? globalThis.Number(object.overall_performance)
        : 0,
      percentWeedsBroadleaf: isSet(object.percentWeedsBroadleaf)
        ? globalThis.Number(object.percentWeedsBroadleaf)
        : isSet(object.percent_weeds_broadleaf)
        ? globalThis.Number(object.percent_weeds_broadleaf)
        : 0,
      percentWeedsDisregard: isSet(object.percentWeedsDisregard)
        ? globalThis.Number(object.percentWeedsDisregard)
        : isSet(object.percent_weeds_disregard)
        ? globalThis.Number(object.percent_weeds_disregard)
        : 0,
      percentWeedsGrass: isSet(object.percentWeedsGrass)
        ? globalThis.Number(object.percentWeedsGrass)
        : isSet(object.percent_weeds_grass)
        ? globalThis.Number(object.percent_weeds_grass)
        : 0,
      percentWeedsOffshoot: isSet(object.percentWeedsOffshoot)
        ? globalThis.Number(object.percentWeedsOffshoot)
        : isSet(object.percent_weeds_offshoot)
        ? globalThis.Number(object.percent_weeds_offshoot)
        : 0,
      percentWeedsPurslane: isSet(object.percentWeedsPurslane)
        ? globalThis.Number(object.percentWeedsPurslane)
        : isSet(object.percent_weeds_purslane)
        ? globalThis.Number(object.percent_weeds_purslane)
        : 0,
      thinningPerformance: isSet(object.thinningPerformance)
        ? globalThis.Number(object.thinningPerformance)
        : isSet(object.thinning_performance)
        ? globalThis.Number(object.thinning_performance)
        : 0,
      weedDensityPerSqMeter: isSet(object.weedDensityPerSqMeter)
        ? globalThis.Number(object.weedDensityPerSqMeter)
        : isSet(object.weed_density_per_sq_meter)
        ? globalThis.Number(object.weed_density_per_sq_meter)
        : 0,
      weedingPerformance: isSet(object.weedingPerformance)
        ? globalThis.Number(object.weedingPerformance)
        : isSet(object.weeding_performance)
        ? globalThis.Number(object.weeding_performance)
        : 0,
      remainingCropDensityPerSqMeter: isSet(object.remainingCropDensityPerSqMeter)
        ? globalThis.Number(object.remainingCropDensityPerSqMeter)
        : isSet(object.remaining_crop_density_per_sq_meter)
        ? globalThis.Number(object.remaining_crop_density_per_sq_meter)
        : 0,
    };
  },

  toJSON(message: JigsawSpatialMetricsCompanion): unknown {
    const obj: any = {};
    if (message.averageCropRadiusMeters !== 0) {
      obj.averageCropRadiusMeters = message.averageCropRadiusMeters;
    }
    if (message.averageTravelSpeedMetersPerSecond !== 0) {
      obj.averageTravelSpeedMetersPerSecond = message.averageTravelSpeedMetersPerSecond;
    }
    if (message.averageWeedRadiusMeters !== 0) {
      obj.averageWeedRadiusMeters = message.averageWeedRadiusMeters;
    }
    if (message.coverageSquareMeters !== 0) {
      obj.coverageSquareMeters = message.coverageSquareMeters;
    }
    if (message.cropDensityPerSqMeter !== 0) {
      obj.cropDensityPerSqMeter = message.cropDensityPerSqMeter;
    }
    if (message.keptCropDensityPerSqMeter !== 0) {
      obj.keptCropDensityPerSqMeter = message.keptCropDensityPerSqMeter;
    }
    if (message.overallPerformance !== 0) {
      obj.overallPerformance = message.overallPerformance;
    }
    if (message.percentWeedsBroadleaf !== 0) {
      obj.percentWeedsBroadleaf = message.percentWeedsBroadleaf;
    }
    if (message.percentWeedsDisregard !== 0) {
      obj.percentWeedsDisregard = message.percentWeedsDisregard;
    }
    if (message.percentWeedsGrass !== 0) {
      obj.percentWeedsGrass = message.percentWeedsGrass;
    }
    if (message.percentWeedsOffshoot !== 0) {
      obj.percentWeedsOffshoot = message.percentWeedsOffshoot;
    }
    if (message.percentWeedsPurslane !== 0) {
      obj.percentWeedsPurslane = message.percentWeedsPurslane;
    }
    if (message.thinningPerformance !== 0) {
      obj.thinningPerformance = message.thinningPerformance;
    }
    if (message.weedDensityPerSqMeter !== 0) {
      obj.weedDensityPerSqMeter = message.weedDensityPerSqMeter;
    }
    if (message.weedingPerformance !== 0) {
      obj.weedingPerformance = message.weedingPerformance;
    }
    if (message.remainingCropDensityPerSqMeter !== 0) {
      obj.remainingCropDensityPerSqMeter = message.remainingCropDensityPerSqMeter;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawSpatialMetricsCompanion>, I>>(base?: I): JigsawSpatialMetricsCompanion {
    return JigsawSpatialMetricsCompanion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawSpatialMetricsCompanion>, I>>(
    object: I,
  ): JigsawSpatialMetricsCompanion {
    const message = createBaseJigsawSpatialMetricsCompanion();
    message.averageCropRadiusMeters = object.averageCropRadiusMeters ?? 0;
    message.averageTravelSpeedMetersPerSecond = object.averageTravelSpeedMetersPerSecond ?? 0;
    message.averageWeedRadiusMeters = object.averageWeedRadiusMeters ?? 0;
    message.coverageSquareMeters = object.coverageSquareMeters ?? 0;
    message.cropDensityPerSqMeter = object.cropDensityPerSqMeter ?? 0;
    message.keptCropDensityPerSqMeter = object.keptCropDensityPerSqMeter ?? 0;
    message.overallPerformance = object.overallPerformance ?? 0;
    message.percentWeedsBroadleaf = object.percentWeedsBroadleaf ?? 0;
    message.percentWeedsDisregard = object.percentWeedsDisregard ?? 0;
    message.percentWeedsGrass = object.percentWeedsGrass ?? 0;
    message.percentWeedsOffshoot = object.percentWeedsOffshoot ?? 0;
    message.percentWeedsPurslane = object.percentWeedsPurslane ?? 0;
    message.thinningPerformance = object.thinningPerformance ?? 0;
    message.weedDensityPerSqMeter = object.weedDensityPerSqMeter ?? 0;
    message.weedingPerformance = object.weedingPerformance ?? 0;
    message.remainingCropDensityPerSqMeter = object.remainingCropDensityPerSqMeter ?? 0;
    return message;
  },
};

function createBaseJigsawBlocksByJobResponse(): JigsawBlocksByJobResponse {
  return { blocks: {} };
}

export const JigsawBlocksByJobResponse: MessageFns<JigsawBlocksByJobResponse> = {
  encode(message: JigsawBlocksByJobResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.blocks).forEach(([key, value]: [string, JigsawBlocksResponse]) => {
      JigsawBlocksByJobResponse_BlocksEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawBlocksByJobResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawBlocksByJobResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = JigsawBlocksByJobResponse_BlocksEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.blocks[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawBlocksByJobResponse {
    return {
      blocks: isObject(object.blocks)
        ? (globalThis.Object.entries(object.blocks) as [string, any][]).reduce(
          (acc: { [key: string]: JigsawBlocksResponse }, [key, value]: [string, any]) => {
            acc[key] = JigsawBlocksResponse.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: JigsawBlocksByJobResponse): unknown {
    const obj: any = {};
    if (message.blocks) {
      const entries = globalThis.Object.entries(message.blocks) as [string, JigsawBlocksResponse][];
      if (entries.length > 0) {
        obj.blocks = {};
        entries.forEach(([k, v]) => {
          obj.blocks[k] = JigsawBlocksResponse.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawBlocksByJobResponse>, I>>(base?: I): JigsawBlocksByJobResponse {
    return JigsawBlocksByJobResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawBlocksByJobResponse>, I>>(object: I): JigsawBlocksByJobResponse {
    const message = createBaseJigsawBlocksByJobResponse();
    message.blocks = (globalThis.Object.entries(object.blocks ?? {}) as [string, JigsawBlocksResponse][]).reduce(
      (acc: { [key: string]: JigsawBlocksResponse }, [key, value]: [string, JigsawBlocksResponse]) => {
        if (value !== undefined) {
          acc[key] = JigsawBlocksResponse.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseJigsawBlocksByJobResponse_BlocksEntry(): JigsawBlocksByJobResponse_BlocksEntry {
  return { key: "", value: undefined };
}

export const JigsawBlocksByJobResponse_BlocksEntry: MessageFns<JigsawBlocksByJobResponse_BlocksEntry> = {
  encode(message: JigsawBlocksByJobResponse_BlocksEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      JigsawBlocksResponse.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawBlocksByJobResponse_BlocksEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawBlocksByJobResponse_BlocksEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = JigsawBlocksResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawBlocksByJobResponse_BlocksEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? JigsawBlocksResponse.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: JigsawBlocksByJobResponse_BlocksEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = JigsawBlocksResponse.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawBlocksByJobResponse_BlocksEntry>, I>>(
    base?: I,
  ): JigsawBlocksByJobResponse_BlocksEntry {
    return JigsawBlocksByJobResponse_BlocksEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawBlocksByJobResponse_BlocksEntry>, I>>(
    object: I,
  ): JigsawBlocksByJobResponse_BlocksEntry {
    const message = createBaseJigsawBlocksByJobResponse_BlocksEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? JigsawBlocksResponse.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
